// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2SrET","header":"PatientQuestionnaire_header__Nj03S","info":"PatientQuestionnaire_info__VGBua"};